import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.ScrollHeader.init($self)
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'md',
				toggle: '<i class="fa fa-chevron-down"></i>',
				hamburger: '<svg id="hamburger-nav" viewBox="0 0 100 100"><path class="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"></path><path class="line line2" d="M 20,50 H 80"></path><path class="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"></path></svg>'
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableLawCookie: function () {
			new VGLawCookie({
				enableLinkMore: true,
			});
		},

		enableNiceSelect: function ()  {
			$('.nice-select').niceSelect();
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	ScrollHeader: {
		sticky: '.header',
		offset: 0,

		init: function ($self) {
			let _this = this,
				sticky = document.querySelector(_this.sticky);

			if (sticky) {
				_this.scroll($self, sticky)
			}
		},

		scroll: function ($window, $element) {
			let _this = this,
				scrollTop = $window.scrollTop(),
				$body = document.body;

			if (scrollTop > _this.offset) {
				$body.classList.add('header--is-fixed');
				$element.classList.add('fixed');
			} else {
				$body.classList.remove('header--is-fixed');
				$element.classList.remove('fixed');
			}
		}
	}
}


export default VGListener;